import { render } from "./FooterBar.vue?vue&type=template&id=24ababfa&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=24ababfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ababfa"]])

export default __exports__